import { getCloudinaryUrl } from "@swiggy-private/core-ui";
import { CloudinaryOptions } from "@swiggy-private/js-utils/dist/cloudinary/types";

export const PAYMENT_ICON_HEIGHT = 64;

export const getIconCloudinaryUrl = (iconPath: string, options: CloudinaryOptions = {}): string => {
    return getCloudinaryUrl(iconPath, {
        // restricting height of the icon to be rendered in case it is not passed from the caller
        height: PAYMENT_ICON_HEIGHT,
        ...options,
    });
};
